import { createSlice } from '@reduxjs/toolkit';

export const eventSlice = createSlice({
  name: 'event',
  initialState: {
    eventId: null,
    healthCampsEventRecords: null,
    pharmaEventRecords: null,
    franchiseEventRecords: null,
    healthySportsEventRecords: null
  },
  reducers: {
    pushEventId: (state, action) => {
      state.eventId = action.payload;
    },
    popEventId: (state) => {
      state.eventId = null;
    },
    pushHealthCampsEventRecords: (state, action) => {
      state.healthCampsEventRecords = action.payload;
    },
    popHealthCampsEventRecords: (state) => {
      state.healthCampsEventRecords = null
    },
    pushPharmaEventRecords: (state, action) => {
      state.pharmaEventRecords = action.payload;
    },
    popPharmaEventRecords: (state) => {
      state.pharmaEventRecords = null
    },
    pushFranchiseEventRecords: (state, action) => {
      state.franchiseEventRecords = action.payload;
    },
    popFranchiseEventRecords: (state) => {
      state.franchiseEventRecords = null
    },
    pushHealthySportsEventRecords: (state, action) => {
      state.healthySportsEventRecords = action.payload;
    },
    popHealthySportsEventRecords: (state) => {
      state.healthySportsEventRecords = null
    }
  },
});

export const { pushEventId, popEventId, pushHealthCampsEventRecords, popHealthCampsEventRecords, pushPharmaEventRecords, popPharmaEventRecords, pushFranchiseEventRecords, popFranchiseEventRecords, pushHealthySportsEventRecords, popHealthySportsEventRecords } = eventSlice.actions;

export const selectEventId = (state) => state.event.eventId;

export const selectHealthCampsEventRecords = (state) => state.event.healthCampsEventRecords;

export const selectPharmaEventRecords = (state) => state.event.pharmaEventRecords;

export const selectFranchiseEventRecords = (state) => state.event.franchiseEventRecords;

export const selectHealthySportsEventRecords = (state) => state.event.healthySportsEventRecords;

export default eventSlice.reducer;
